var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pb-2" }, [
      _c("label", { attrs: { for: "service" } }, [
        _vm._v(_vm._s(_vm.__("globals.filter_activity_by_service"))),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.service,
              expression: "service",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "service" + this._uid },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.service = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _c("option", { attrs: { value: "" } }, [
            _vm._v(_vm._s(_vm.__("globals.search_service_filter"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Event" } }, [
            _vm._v(_vm._s(_vm.__("globals.event"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Group" } }, [
            _vm._v(_vm._s(_vm.__("globals.group"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Job" } }, [
            _vm._v(_vm._s(_vm.__("globals.job"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Product" } }, [
            _vm._v(_vm._s(_vm.__("globals.product"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Resource" } }, [
            _vm._v(_vm._s(_vm.__("globals.resource"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Supplier" } }, [
            _vm._v(_vm._s(_vm.__("globals.supplier"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Ticket" } }, [
            _vm._v(_vm._s(_vm.__("globals.ticket"))),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "App\\Models\\Video" } }, [
            _vm._v(_vm._s(_vm.__("globals.video"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.service !== ""
      ? _c(
          "div",
          [
            _c(
              "ul",
              { staticClass: "list-unstyled" },
              _vm._l(_vm.activities, function (activity, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "list-group-item" },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", [
                        _c(
                          "a",
                          { attrs: { href: activity.url, target: "_blank" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.capitalizeTheFirstLetterOfEachWord(
                                  activity.type
                                )
                              ) +
                                " - " +
                                _vm._s(
                                  activity.subject !== null
                                    ? activity.subject.title
                                    : ""
                                )
                            ),
                          ]
                        ),
                        _vm._v(
                          " on " +
                            _vm._s(_vm.activityDate(activity.created_at)) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      activity.subject === null
                        ? _c("div", { staticClass: "ml-auto" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-pill badge-danger font-size-xsmall",
                              },
                              [_vm._v(_vm._s(_vm.__("globals.deleted")))]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "infinite-loading",
              {
                attrs: { identifier: _vm.infiniteId },
                on: {
                  distance: function ($event) {
                    1
                  },
                  infinite: _vm.infiniteHandler,
                },
              },
              [
                _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { slot: "no-results" }, slot: "no-results" },
                  [_vm._v(" " + _vm._s(_vm.__("globals.no_activities_found")))]
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }